module.exports = __webpack_public_path__ + "media/37.fa552e07.ogg";